import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { Box, Typography, Tooltip } from '@mui/material';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import ShowComponents from '../Common/ShowComponent';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';

class DocVitalsLeft extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isDeleteCliked: false,
            SelectedList: {},
            PatientData: this.props?.PatientData,
            height: '',
            weight: '',
            bp_d: '',
            bp_s: '',
            temp: '',
            spo2: '',
            pulserate: '',
            bloodglucouse: '',
            tempUnit: 'F',
            obs_ExpectedDeliveryDate: null,
            obs_LastMenstrualPeriod: null,
            gestational_weeks: "",
            gestational_days: "",
            show_waist_circumference: false,
            waist_circumference: '',
            vital_entered_time : '',
            oxygen_source: "",
            oxygen_support: "",
        }
    }

    componentDidMount() {
        let show_waist_circumference = JSON.parse(localGetItem('loggedInUserInfo'))?.show_waist_circumference
        this.setState({ show_waist_circumference: show_waist_circumference })
    }

    componentDidUpdate(prevprops) {
        if (prevprops.GetAPiCall !== this.props.GetAPiCall && this.props.GetAPiCall) { this.getDoctorNotesVitalData();}
    }

    getDoctorNotesVitalData = () => {
        try {
            let appointmentId = this.props.PatientData?.appointment_id
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_VITALS + `?appointment_id=${appointmentId}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        if (response.data.data?.length > 0) {
                            this.setState({
                                vitalsData: response.data.data,
                                height: response.data.data[0]?.height_cm,
                                weight: response.data.data[0]?.weight_kg,
                                bp_d: response.data.data[0]?.blood_pressure_diastolic,
                                bp_s: response.data.data[0]?.blood_pressure_systolic,
                                temp: response.data.data[0]?.temperature,
                                spo2: response.data.data[0]?.pulse_oximetry,
                                pulserate: response.data.data[0]?.pulse_rate,
                                bloodglucouse: response.data.data[0]?.blood_sugar,
                                tempUnit: response.data.data[0]?.temperature_unit,
                                bmi: response.data.data[0]?.bmi,
                                bsa: response.data.data[0]?.bsa || '',
                                headCircumference: response.data.data[0]?.head_circumference,
                                obs_ExpectedDeliveryDate: response.data.data[0]?.expected_date_of_delivery,
                                obs_LastMenstrualPeriod: response.data.data[0]?.last_menstrual_period,
                                gestational_weeks: response.data.data[0]?.gestational_age_weeks,
                                gestational_days: response.data.data[0]?.gestational_age_days,
                                waist_circumference: response.data.data[0]?.waist_circumference,
                                oxygen_source: response.data.data[0]?.oxygen_source || "",
                                oxygen_support: response.data.data[0]?.oxygen_support || "",
                            }, () => {
                                this.props.EditVitalsData(response.data.data)
                            })
                        }
                    }
                }).catch(error => {
                    if (error?.response?.data?.message) {
                        this.setState({ loading: false })
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.setState({ loading: false })
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.setState({ loading: false })
            this.errorMessage(error.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    bmiHelperText = (bmi) => {
        try {
            let message = null
            if (bmi <= 18.5) {
                message = 'Mild Thinness'
            } else if (bmi > 18.5 && bmi <= 25) {
                message = 'Normal'
            } else if (bmi > 25 && bmi <= 30) {
                message = 'Overweight'
            } else if (bmi > 30) {
                message = 'Obesity'
            }
            return message;
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    bsaHelperText = (bsa) => {
        try {
            let message = null
            if (bsa < 1.4) {
                message = 'Below Normal'
            } else if (bsa >= 1.4 && bsa <= 2.4) {
                message = 'Normal Range'
            } else if (bsa > 2.4) {
                message = 'Above Normal'
            }
            return message;
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    renderContent = (label, value, unit = "", color = "") => {
        const displayTxt = value ? `${value} ${unit}` : "-"
        return (<Box className="eMed_docVitals_grid_item">
            <Typography className="eMed_docVitals_header_div">{label}</Typography>
            <Typography className="eMed_docVitals_body_div" sx={{ color }}>
                {displayTxt?.length > 15 ?
                    <Tooltip placement='top' title={displayTxt} arrow><div>{displayTxt.slice(0, 15) + '...'}</div></Tooltip>
                    : displayTxt || '-'}
            </Typography>
        </Box>)
    }

    isValid = (value) => value !== "" && value !== 0 && value !== null && value !== undefined && value !== "0" && value !== " ";

    render() {
        try {
            // let bpsColor = this.state.bp_s <= 80 ? "green" : "red"
            // let bpdColor = this.state.bp_d <= 120 ? "green" : "red"
            // let tempColor = ((this.state.tempUnit === 'F' && (this.state.temp >= 97 && this.state.temp <= 99)) || (this.state.tempUnit === 'C' && (this.state.temp >= 36.1 && this.state.temp <= 37.2))) ? 'green' : 'red'
            // let spo2Color = (this.state.spo2 >= 95 && this.state.spo2 <= 100) ? "green" : "red"
            // let rateColor = (this.state.pulserate >= 60 && this.state.pulserate) ? 'green' : 'red'
            // let bloodColor = this.state.bloodglucouse <= 200 ? 'green' : 'red'
            return (
                <ShowComponents onIntersection={this.getDoctorNotesVitalData.bind(this)}>
                    {this.state.vitalsData?.map((vitalItem, index) => {
                        const contentItems = [];

                        this.props.filteredRightField_data?.forEach(config => {
                            switch (config.field_name) {
                                case "height":
                                    if (this.isValid(vitalItem.height_cm))
                                        contentItems.push(this.renderContent("Height", vitalItem.height_cm, "cm"));
                                    break;

                                case "weight":
                                    if (this.isValid(vitalItem.weight_kg)) {
                                        contentItems.push(this.renderContent("Weight", vitalItem.weight_kg, "kg"));
                                    }
                                    break;
                                    case "heart_rate":
                                    if (this.isValid(vitalItem.heart_rate)) {
                                        const hrColor =
                                            vitalItem.heart_rate >= 60 && vitalItem.heart_rate <= 100
                                                ? "green"
                                                : "red";
                                        contentItems.push(
                                            this.renderContent("Heart Rate", vitalItem.heart_rate, "bpm", hrColor)
                                        );
                                    }
                                    break;

                                case "respiratory_rate":
                                    if (this.isValid(vitalItem.respiratory_rate)) {
                                        const rrColor =
                                            vitalItem.respiratory_rate >= 12 && vitalItem.respiratory_rate <= 20
                                                ? "green"
                                                : "red";
                                        contentItems.push(
                                            this.renderContent(
                                                "Respiratory Rate",
                                                vitalItem.respiratory_rate,
                                                "breaths/min",
                                                rrColor
                                            )
                                        );
                                    }
                                    break;

                                case "capillary_refill_time":
                                    if (this.isValid(vitalItem.capillary_refill_time)) {
                                        let crtColor =
                                            vitalItem.capillary_refill_time === "<2"
                                                ? "green"
                                                : vitalItem.capillary_refill_time === ">2-<3"
                                                    ? "orange"
                                                    : "red";
                                        contentItems.push(
                                            this.renderContent(
                                                "Capillary Refill Time",
                                                vitalItem.capillary_refill_time,
                                                "sec",
                                                crtColor
                                            )
                                        );
                                    }
                                break;
                                case "bmi":
                                    // render bmi after weight if the height presents
                                    if (this.isValid(vitalItem.height_cm) && this.isValid(vitalItem.weight_kg) && this.isValid(vitalItem.bmi)) {
                                        contentItems.push(
                                            <Box className="eMed_docVitals_grid_item">
                                                <Typography className="eMed_docVitals_header_div">BMI</Typography>
                                                <Box
                                                    className="eMed_Vitals_body_div"
                                                    sx={{
                                                        backgroundColor: vitalItem.bmi < 18.5 ? "#FFCCCB" :
                                                            vitalItem.bmi <= 25 ? "lightgreen" :
                                                                vitalItem.bmi <= 30 ? "#FBB917" : "#FF6863",
                                                        borderRadius: "0.5vw", p: "0.5vw"
                                                    }}
                                                >
                                                    <Typography>{vitalItem.bmi}</Typography>
                                                    <Typography sx={{ fontSize: "0.8vw" }}>{this.bmiHelperText(vitalItem.bmi)}</Typography>
                                                </Box>
                                            </Box>
                                        );
                                    }
                                    break;
                                case "bsa":
                                    if (this.isValid(vitalItem.height_cm) && this.isValid(vitalItem.weight_kg) && this.isValid(vitalItem.bsa)) {
                                        contentItems.push(
                                            <Box className="eMed_docVitals_grid_item">
                                                <Typography className="eMed_docVitals_header_div">BSA</Typography>
                                                <Box
                                                    className="eMed_Vitals_body_div"
                                                    sx={{
                                                        backgroundColor: ((vitalItem.bsa >= 1.4) && (vitalItem.bsa <= 2.4)) ?
                                                            'lightgreen' : ((vitalItem.bsa < 1.4)) ? '#FBB917' : '#FF6863',
                                                        borderRadius: "0.5vw", p: "0.5vw"
                                                    }}
                                                >
                                                    <Typography>{vitalItem.bsa}</Typography>
                                                    <Typography sx={{ fontSize: "0.8vw" }}>{this.bsaHelperText(vitalItem.bsa)}</Typography>
                                                </Box>
                                            </Box>
                                        );
                                    }
                                    break;
                                case "bpsystolic":
                                    if (this.isValid(vitalItem.blood_pressure_systolic))
                                        contentItems.push(this.renderContent("Systolic BP", vitalItem.blood_pressure_systolic, "mm/Hg", vitalItem.blood_pressure_systolic <= 80 ? "green" : "red"));
                                    break;
                                case "bpdistolic":
                                    if (this.isValid(vitalItem.blood_pressure_diastolic))
                                        contentItems.push(this.renderContent("Diastolic BP", vitalItem.blood_pressure_diastolic, "mm/Hg", vitalItem.blood_pressure_diastolic <= 120 ? "green" : "red"));
                                    break;

                                case "temp":
                                    if (this.isValid(vitalItem.temperature)) {
                                        const tempColor = (
                                            (vitalItem.temperature_unit === 'F' && vitalItem.temperature >= 97 && vitalItem.temperature <= 99) ||
                                            (vitalItem.temperature_unit === 'C' && vitalItem.temperature >= 36.1 && vitalItem.temperature <= 37.2)
                                        ) ? 'green' : 'red';
                                        contentItems.push(this.renderContent("Temperature", vitalItem.temperature, `°${vitalItem.temperature_unit}`, tempColor));
                                    }
                                    break; 

                                case "spo2":
                                    if (this.isValid(vitalItem.pulse_oximetry))
                                        contentItems.push(this.renderContent("Pulse Oximetry", vitalItem.pulse_oximetry, "%", (vitalItem.pulse_oximetry >= 95 && vitalItem.pulse_oximetry <= 100) ? "green" : "red"));
                                    break;

                                case "pulse":
                                    if (this.isValid(vitalItem.pulse_rate))
                                        contentItems.push(this.renderContent("Pulse Rate", vitalItem.pulse_rate, "/min", vitalItem.pulse_rate >= 60 ? "green" : "red"));
                                    break;

                                case "blood_glucose":
                                    if (this.isValid(vitalItem.blood_sugar))
                                        contentItems.push(this.renderContent("Random Blood Glucose", vitalItem.blood_sugar, "mg/dL", vitalItem.blood_sugar <= 200 ? "green" : "red"));
                                    break;

                                case "waist_circumference":
                                    if (this.isValid(vitalItem.waist_circumference))
                                        contentItems.push(this.renderContent("Waist Circumference", vitalItem.waist_circumference, "cm"));
                                    break;

                                case "head_circumference":
                                    if (this.isValid(vitalItem.head_circumference))
                                        contentItems.push(this.renderContent("Head Circumference", vitalItem.head_circumference, "cm"));
                                    break;

                                case "comments":
                                    if (this.isValid(vitalItem.comments))
                                        contentItems.push(this.renderContent("Comments", vitalItem.comments));
                                    break;

                                case "expected_date_of_delivery":
                                    if (this.isValid(vitalItem.expected_date_of_delivery))
                                        contentItems.push(this.renderContent("Expected Date of Delivery", formatDate(vitalItem.expected_date_of_delivery)));
                                    break;
                                case "corrected_edd":
                                    if (this.isValid(vitalItem.corrected_edd))
                                        contentItems.push(this.renderContent("Corrected EDD", formatDate(vitalItem.corrected_edd)));
                                    break;

                                case "last_mensural":
                                    if (this.isValid(vitalItem.last_menstrual_period))
                                        contentItems.push(this.renderContent("Last Menstrual Period", formatDate(vitalItem.last_menstrual_period)));
                                    break;

                                case "vital_data_time":
                                    if (this.isValid(vitalItem.vital_entered_time))
                                        contentItems.push(this.renderContent("Vital Date", formatDate(vitalItem.vital_entered_time)));
                                    break;

                                case "gestational_age":
                                    if (this.isValid(vitalItem.gestational_age_days))
                                        contentItems.push(this.renderContent("Gestational Age", `${vitalItem.gestational_age_weeks || 0} ${vitalItem.gestational_age_weeks === 1 ? "Week" : "Weeks"} ${vitalItem.gestational_age_days || 0} ${vitalItem.gestational_age_days === 1 ? "Day" : "Days"}`));
                                    break;

                                case "nurse_name":
                                    if (this.isValid(vitalItem.nurse_name))
                                        contentItems.push(this.renderContent("Nurse Name", vitalItem.nurse_name));
                                    break;
                                case "oxygensource":
                                    if (this.isValid(vitalItem.oxygen_source)) {
                                        contentItems.push(this.renderContent("Oxygen Source", vitalItem.oxygen_source, ""));
                                        if (vitalItem.oxygen_source === "O2 (With Oxygen)" && this.isValid(vitalItem.oxygen_support)) {
                                            contentItems.push(this.renderContent("Oxygen Support", vitalItem.oxygen_support, "L/min"));
                                        }
                                    }
                                    break;

                                default:
                                    break;
                            }
                        });

                        // Fill the remaining cells if not multiple of 5
                        const fillerCount = contentItems.length % 5 === 0 ? 0 : 5 - (contentItems.length % 5);
                        for (let i = 0; i < fillerCount; i++) contentItems.push(this.renderContent("", " "));
                        return (
                            <Box
                                key={index}
                                className="eMed_docVitals_container"
                                height={this.props?.UserInfo?.service_type === "PD" || this.props?.UserInfo?.service_type === "OBGYN" ? "43vh" : "30vh"}
                            >
                                {contentItems}
                            </Box>
                        );
                    })}
                    {this.state.isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                    {this.state.successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={this.state.successMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                </ShowComponents>
            )
        }
        catch (e) {

        }
    }
}
export default withTranslation()(DocVitalsLeft)

